import React from 'react';
import PropTypes from 'prop-types';

/**
 * SVG-based loading spinner.
 * @param {string} className - Tailwind classes for size and colour, e.g. "w-10 h-10 text-sky-500"
 */
const Spinner = ({ className = 'w-6 h-6 text-sky-500' }) => (
  <svg
    className={`animate-spin ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-label="Loading"
    role="status"
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
  </svg>
);

Spinner.propTypes = {
  className: PropTypes.string,
};

export default Spinner;
